export default __webpack_public_path__ + "media/images/ui-icons_222222_256x240-23aca9c182696db96ff9ee5bf9601461.png";